import * as React from 'react';
import {faExclamationCircle} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

import {DisplayCurrencyFormatted} from '../orders/display-currency-formatted/DisplayCurrencyFormatted';
import {Item} from '../items/item.class';
import {PriceObjectErrorType, PriceUnit} from './price.types';
import {Tooltip} from '../ui/Tooltip/Tooltip';

interface PriceLineProps {
    basePrice?: boolean;
    boldPrice?: boolean;
    className?: string;
    currency?: string;
    doNotShowEachPrice?: boolean;
    eachPrice?: number;
    error?: string;
    errorType?: PriceObjectErrorType;
    isActionBlock?: boolean;
    isItemCard?: boolean;
    isItemSpinner?: boolean;
    isPkgQty1?: boolean;
    login?: boolean;
    onLogon: () => void;
    onSale?: boolean;
    price?: number;
    showCurrencyTooltip?: boolean;
    unit?: PriceUnit;
}

export const PriceLine = ({
    basePrice = false,
    boldPrice = false,
    className,
    currency,
    doNotShowEachPrice,
    eachPrice,
    error,
    errorType,
    isActionBlock = false,
    isItemCard = false,
    isItemSpinner = false,
    isPkgQty1,
    login = false,
    onLogon,
    onSale = false,
    price,
    showCurrencyTooltip,
    unit,
}: PriceLineProps) => {
    // Error messaging template
    if (errorType === `CONVERT`) {
        return (
            <div
                className={`ImpItem_priceLine ${
                    error !== `BLOCKED` ? ` tw-text-right tw-justify-end tw-flex tw-relative${!isItemCard ? ' tw-top-2' : ''}` : ''
                }`}
            >
                {error === `BLOCKED` ? (
                    <>Item Blocked</>
                ) : (
                    <div
                        className={`tw-table-cell tw-leading-[14px] tw-align-bottom tw-pt-1${
                            isItemSpinner ? ' !tw-font-bold !tw-text-xl' : `${isActionBlock ? ' tw-mr-auto' : ''}`
                        }`}
                    >
                        Order Item:{' '}
                        <a
                            className={`${isItemSpinner ? ' !tw-font-bold !tw-text-xl' : ''}`}
                            href={`/item/${error}`}
                        >
                            {Item.prettyItem(error)}
                        </a>
                    </div>
                )}
            </div>
        );
    } else if (errorType === `BLOCKED`) {
        return (
            <div
                className="ImpItem_priceLine"
                style={{lineHeight: `15px`, fontSize: `12px`}}
            >
                Item cannot be purchased
            </div>
        );
    } else if (error) {
        return <div className="ImpItem_priceLine">{error}</div>;
    }
    if (className) {
        className = ` ${className}`;
    }

    // Login template
    if (login) {
        return (
            <div className={`ImpItem_priceLine${isItemSpinner ? ' tw-mt-2' : ''}${className ? ` ${className}` : ''}`}>
                {isItemSpinner ? (
                    <a
                        className="tw-text-xl tw-font-bold tw-text-blue-200 hover:tw-no-underline"
                        onClick={(e) => {
                            e.preventDefault();
                            onLogon();
                        }}
                        href="/login"
                    >
                        View Price
                    </a>
                ) : (
                    <a
                        onClick={(e) => {
                            e.preventDefault();
                            onLogon();
                        }}
                        href="/login"
                    >
                        Log In To See Pricing
                    </a>
                )}
            </div>
        );
    }

    // Standard template
    return (
        <>
            <div
                className={`ImpItem_priceLine ${
                    onSale && !basePrice ? ' tw-text-green-200' : `tw-relative${!isItemCard ? ' tw-top-2' : ''}`
                }${boldPrice ? ' !tw-font-bold !tw-text-base' : ''} ${
                    isItemSpinner
                        ? `${basePrice ? '!tw-text-sm' : '!tw-text-xl'}`
                        : `${isActionBlock ? '!tw-text-[28px]' : '!tw-text-base'}`
                }${basePrice ? ' basePrice' : ''}${className || ''}`}
            >
                <DisplayCurrencyFormatted
                    amount={price}
                    boldPrice={boldPrice}
                />{' '}
                pkg
                {!doNotShowEachPrice && unit?.toLowerCase() !== 'pk' && eachPrice !== 0 && !isPkgQty1 && (
                    <span>
                        &nbsp;| <DisplayCurrencyFormatted amount={eachPrice} /> {unit?.toLowerCase()}
                    </span>
                )}
                {currency && showCurrencyTooltip && (
                    <>
                        {' '}
                        <Tooltip
                            id="pricing-details"
                            title={`Prices are in ${currency}`}
                        >
                            <FontAwesomeIcon
                                icon={faExclamationCircle}
                                size="2x"
                            />
                        </Tooltip>
                    </>
                )}
            </div>
        </>
    );
};
